export const NATIONALITIES = [
  'سعودي', 'فلبيني', 'مصري', 'سوري', 'سوداني', 'فلسطيني', 'هندي', 'بنجلاديشي', 'يمني',
  'أردني', 'إماراتي', 'بحريني', 'تونسي', 'جزائري', 'عراقي', 'عماني', 'قطري', 'كويتي',
  'لبناني', 'ليبي', 'مغربي', 'باكستاني', 'سريلانكي', 'نيبالي', 'إندونيسي', 'إثيوبي',
  'كيني', 'نيجيري', 'تركي', 'أمريكي', 'بريطاني', 'كندي', 'فرنسي', 'ألماني', 'أخرى'
];
